import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addItem: {
    id: 'footer-channels-settings-additem',
    defaultMessage: 'Add item',
  },
  moveItemUp: {
    id: 'footer-channels-settings-move-item-up',
    defaultMessage: 'Move item up',
  },
  moveItemDown: {
    id: 'footer-channels-settings-move-item-down',
    defaultMessage: 'Move item down',
  },
  title: {
    id: 'footer-channels-settings-title',
    defaultMessage: 'Title',
  },
  url: {
    id: 'footer-channels-settings-url',
    defaultMessage: 'URL',
  },
  deleteItem: {
    id: 'footer-channels-settings-delete-item',
    defaultMessage: 'Delete channel',
  },
  links: {
    id: 'footer-channels-settings-links',
    defaultMessage: 'Links',
  },
  linkNumber: {
    id: 'footer-channels-settings-link-number',
    defaultMessage: 'Link',
  },
  linkName: {
    id: 'footer-channels-settings-link-name',
    defaultMessage: 'Nome do link',
  },
  linkUrl: {
    id: 'footer-channels-settings-link-url',
    defaultMessage: 'URL do link',
  },
  addLink: {
    id: 'footer-channels-settings-add-link',
    defaultMessage: 'Adicionar link',
  },
  deleteLink: {
    id: 'footer-channels-settings-delete-link',
    defaultMessage: 'Excluir link',
  },
});
